var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('l-polygon',{attrs:{"lat-lngs":_vm.polyLatLng,"color":_vm.polyColor,"opacity":0.3,"fillColor":_vm.polyColor}},[_c('l-tooltip',[_vm._v(" "+_vm._s(_vm.polyHint)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }